/**
 * @generated SignedSource<<6fe6f0ca880b2896a28afe4377f2bbff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_item" | "ProductImage_item">;
  readonly " $fragmentType": "BuyerProductTile_item";
};
export type BuyerProductTile_item$key = {
  readonly " $data"?: BuyerProductTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "500b8e580952dbcb8c464f6dd4ba002a";

export default node;
